module.exports = __webpack_public_path__ + "media/illustration@2x_9a645a.png";